<template>
  <div class="js-author-detail">
    <div class="content-header">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'shopTypeList' }">店铺分类列表</router-link>
        </li>
        <li class="active">详情（新增/修改）</li>
      </ol>
    </div>
    <div class="content-from">
      <el-form ref="formName" :model="shopType" label-width="auto">
        <el-form-item label="店铺分类名称">
            <el-input v-model="shopType.name" placeholder="店铺分类名称"></el-input>
        </el-form-item>
        <el-form-item label="LOGO">
          <Upload ref="upload" :uploadData="uploadData" :defaultFilePath="shopType.iconPath"></Upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save" size="small" >保存</el-button>
          <el-button @click="$router.back(-1)" size="small">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import Upload from '@/components/upload';
export default {
    components:{
        Upload
    },
    data() {
        return {
            uploadData: {
                fileNamePre: 'img',
                folder: 'shopType',
            },
            shopType: {},
            shopTypeId: "",
            dynamicPath:config.dynamicResourcePath,
        };
    },
    created() {
        this.shopTypeId = this.$route.query.shopTypeId;
        if (this.shopTypeId) {
            this.shopTypeDetail();
        }
    },
    methods: {
        save() {
            var _this = this;
            _this.shopType.iconPath = _this.$refs['upload'].getIconPath();
            _this.$common.ajaxRequest({
                url: '/shopType/saveShopType',
                data: _this.shopType,
                success: resp => {
                    _this.$message.success('保存成功')
                    _this.$router.back(-1);
                }
            })
        },
        shopTypeDetail() {
            var _this = this;
            _this.$common.ajaxRequest({
                url: '/shopType/detailShopType',
                data: {
                    shopTypeId: _this.shopTypeId
                },
                success: resp => {
                    _this.shopType = resp.item || {};
                }
            })
        },
    },
};
</script>